import { Component, OnInit, TemplateRef } from "@angular/core";
import { NotificationService } from "src/app/services/notification.service";
import { ToastService } from "../toast.service";

@Component({
   selector: "app-toast-frame",
   templateUrl: "./toast-frame.component.html",
   styleUrls: ["./toast-frame.component.scss"],
   host: { "[class.ngb-toasts]": "true" },
})
export class ToastFrameComponent implements OnInit {
   ngOnInit(): void {}
   constructor(public toastService: ToastService, private notificatiosService: NotificationService) {}

   isTemplate(toast) {
      return toast.textOrTempl instanceof TemplateRef;
   }
}
